(function () {
  'use strict';

  var PV_COOKIE = 'iuh_page_views';
  var PV_DAYS = 1;
  var MIN_PAGES = 2;

  function getCookie(name) {
    var match = document.cookie.split(';').find(function (c) {
      return c.trim().indexOf(name + '=') === 0;
    });
    return match ? decodeURIComponent(match.split('=')[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function pageViews() {
    return parseInt(getCookie(PV_COOKIE) || '0', 10) || 0;
  }

  function incrementPageViews() {
    setCookie(PV_COOKIE, String(pageViews() + 1), PV_DAYS);
  }

  function privacyBannerRequired() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        return window.Shopify.customerPrivacy.shouldShowBanner();
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function privacyBannerVisible() {
    if (privacyBannerRequired() === false) return false;
    return Array.prototype.some.call(document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog'), visible);
  }

  function consentResolved() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        if (window.Shopify.customerPrivacy.shouldShowBanner() === false) return true;
        var c = window.Shopify.customerPrivacy.currentVisitorConsent();
        if (c) {
          if (c.analytics === 'yes' || c.marketing === 'yes' || c.preferences === 'yes') return true;
          if (c.analyticsProcessing === 'yes' || c.marketingAllowed === 'yes' || c.preferencesProcessing === 'yes') return true;
        }
      }
    } catch (e) { /* ignore */ }
    if (privacyBannerRequired() === false) return true;
    if (!privacyBannerVisible()) return true;
    return false;
  }

  function isReady() {
    return pageViews() >= MIN_PAGES && consentResolved();
  }

  function visible(node) {
    if (!node || !node.getClientRects().length) return false;
    var style = getComputedStyle(node);
    return style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  }

  function canPrompt(ignoreSurveys) {
    if (!isReady() || document.hidden || browsingProducts() || (!ignoreSurveys && window.__surveyActive)) return false;
    var focused = document.activeElement;
    if (focused && focused.matches('input, textarea, select, [contenteditable="true"]') && !(ignoreSurveys && focused.closest('.survey-container'))) return false;
    var blockers = document.querySelectorAll('.modal.show, .modal.in, .mini-cart.active, .js-mini-cart.active, .drawer--is-open, .qm-layout--full-screen, dialog[open], [role="dialog"][aria-modal="true"]' + (ignoreSurveys ? '' : ', .survey-container.sv-visible'));
    if (Array.prototype.some.call(blockers, visible)) return false;
    var chat = document.querySelector('shopify-chat');
    if (chat && (chat.hasAttribute('open') || (chat.shadowRoot && chat.shadowRoot.querySelector('[part="activator"][aria-expanded="true"]')))) return false;
    return !privacyBannerVisible();
  }

  var readyCallbacks = [];
  var fired = false;

  function fireReady() {
    if (fired || !isReady()) return;
    fired = true;
    readyCallbacks.forEach(function (fn) { fn(); });
    readyCallbacks = [];
    document.dispatchEvent(new CustomEvent('iuh:popups-ready'));
  }

  function pollReady() {
    if (isReady()) fireReady();
  }

  window.IUHPopupOrchestrator = {
    minPageViews: MIN_PAGES,
    pageViews: pageViews,
    ready: isReady,
    canPrompt: canPrompt,
    onReady: function (fn) {
      if (fired) { fn(); return; }
      readyCallbacks.push(fn);
      pollReady();
    },
  };

  incrementPageViews();

  document.addEventListener('shopify:customer_privacy:consentAccepted', fireReady);
  document.addEventListener('iuh:cookie-banner-suppressed', fireReady);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, [id*="shopify-pc"][id*="accept"]')) {
      setTimeout(fireReady, 300);
    }
  });

  function browsingProducts() {
    return window.__iuhProductBrowseUntil && Date.now() < window.__iuhProductBrowseUntil;
  }

  function bindNewsletter() {
    if (!window.jQuery || bindNewsletter.bound) return;
    bindNewsletter.bound = true;
    window.jQuery(document).on('show.bs.modal', '[id^="jsPopupNewsletter"]', function (e) {
      if (!canPrompt() || window.__iuhExitShown) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  }
  bindNewsletter();

  // The app embed also supplies SurveyEngine. Adapt the final loaded version
  // so app modes and theme modes share the same collision checks.
  function coordinateSurveys() {
    var proto = window.SurveyEngine && window.SurveyEngine.prototype;
    if (!proto || proto.__iuhCoordinated) return;
    proto.__iuhCoordinated = true;
    var show = proto.show;
    proto.show = function () {
      if (this.trigger !== 'manual' && !canPrompt()) return false;
      show.apply(this, arguments);
      return this.isVisible;
    };
    var attach = proto.attachTrigger;
    proto.attachTrigger = function () {
      // Older app versions intercept Back for exit intent. Keep desktop exit
      // intent and use an idle trigger on touch screens without adding history.
      if (this.trigger === 'exit-intent') {
        if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
          this.trigger = 'idle';
        } else {
          var self = this;
          var exit = function (event) {
            if (event.clientY > 10 || window.__iuhExitShown) return;
            if (self.show()) {
              window.__iuhExitShown = true;
              document.removeEventListener('mouseleave', exit);
            }
          };
          document.addEventListener('mouseleave', exit);
          return;
        }
      }
      return attach.apply(this, arguments);
    };
  }
  document.addEventListener('DOMContentLoaded', coordinateSurveys);
  if (document.readyState !== 'loading') coordinateSurveys();

  var widgetStyle = document.createElement('style');
  widgetStyle.textContent = '.survey-container[data-iuh-waiting]{visibility:hidden!important;pointer-events:none!important}.survey-container[data-iuh-waiting] *{visibility:hidden!important;pointer-events:none!important}@media(max-width:749px){.template-product .progress-wrap{bottom:calc(90px + env(safe-area-inset-bottom,0px))!important;left:12px!important;right:auto!important}.survey-container .sv-card{max-height:calc(var(--iuh-visible-height,100dvh) - 24px);overflow-y:auto;overscroll-behavior:contain}}';
  document.head.appendChild(widgetStyle);
  function viewportHeight() {
    document.documentElement.style.setProperty('--iuh-visible-height', (window.visualViewport ? window.visualViewport.height : window.innerHeight) + 'px');
  }
  viewportHeight();
  if (window.visualViewport) window.visualViewport.addEventListener('resize', viewportHeight, { passive: true });

  var activePanel = null;
  var panelRetry = null;
  function syncPanels() {
    clearTimeout(panelRetry);
    var panels = Array.from(document.querySelectorAll('.survey-container.sv-visible'));
    if (panels.indexOf(activePanel) === -1) activePanel = panels[0] || null;
    var allowed = canPrompt(true);
    panels.forEach(function (panel) {
      var waiting = !allowed || panel !== activePanel;
      if (panel.hasAttribute('data-iuh-waiting') !== waiting) {
        panel.toggleAttribute('data-iuh-waiting', waiting);
        panel.inert = waiting;
      }
    });
    // A product-browsing cooldown can expire without a DOM mutation. Recheck
    // only while a survey is waiting, rather than polling every storefront page.
    if (panels.length && !allowed && !document.hidden) panelRetry = setTimeout(syncPanels, 1000);
  }
  function watchPanels() {
    new MutationObserver(syncPanels).observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'open', 'aria-expanded']
    });
    syncPanels();
  }
  document.addEventListener('DOMContentLoaded', watchPanels);
  if (document.readyState !== 'loading') watchPanels();
  // Chat's state lives in a shadow root; clicks and focus cross that boundary.
  document.addEventListener('click', function () { setTimeout(syncPanels, 100); }, true);
  document.addEventListener('focusin', syncPanels);
  document.addEventListener('focusout', function () { setTimeout(syncPanels, 0); });
  document.addEventListener('visibilitychange', syncPanels);

  var pollCount = 0;
  var pollTimer = setInterval(function () {
    pollReady();
    bindNewsletter();
    pollCount++;
    if ((fired && bindNewsletter.bound) || pollCount > 120) clearInterval(pollTimer);
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollReady);
  } else {
    pollReady();
  }
})();
